<section class="technical-review__card">

  @if (categories.length > 0) {
    <div class="steps-carousel">
      <button
        type="button"
        class="steps-carousel__control"
        aria-label="Ver categorías anteriores"
        (click)="scrollSteps('previous')"
      >
        <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
      </button>

      <nav #stepsNav class="steps-nav" aria-label="Categorías checklist">
        @for (category of categories; track category[0]) {
          <button
            type="button"
            class="steps-nav__item"
            [class.is-active]="activeStep === $index"
            (click)="stepChange.emit($index)"
          >
            <div class="steps-nav__meta">
              <span class="steps-nav__index">
                {{ $index + 1 }}
              </span>

              <div class="steps-nav__content">
                <strong>{{ category[0] }}</strong>

                <small> {{ category[1].length }} items </small>
              </div>
            </div>

            @if (activeStep === $index) {
              <div class="steps-nav__active-indicator"></div>
            }
          </button>
        }
      </nav>

      <button
        type="button"
        class="steps-carousel__control"
        aria-label="Ver categorías siguientes"
        (click)="scrollSteps('next')"
      >
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>

    @if (categories[activeStep]; as activeCategory) {
      <section class="checklist-content">
        <app-checklist-category-step
          [categoryName]="activeCategory[0]"
          [items]="activeCategory[1]"
          [decisions]="decisions"
          (decisionChange)="decisionChange.emit($event)"
        ></app-checklist-category-step>
      </section>
    }
  } @else {
    <p class="technical-review__state">{{ emptyMessage }}</p>
  }

  @if (validationErrors.length > 0) {
    <div class="section-validation section-validation--error">
      <div class="section-validation__header">
        <i class="fa-solid fa-triangle-exclamation"></i>

        <strong>Checklist incompleto</strong>
      </div>

      <ul>
        @for (error of validationErrors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }
</section>
